import { LwApiPM } from "@techniaorg/liteweb-api";
import { LwTreeData } from "@techniaorg/liteweb-api/dist/types/lw-public-api";
import { waitForIFrameAndModel } from "../src/util";

// Wait until the iframe is loaded
const myframe = document.querySelector("iframe#webviewer") as HTMLIFrameElement;
let LwAPI: LwApiPM | null = null;
const apiReady: Promise<LwApiPM | null> = waitForIFrameAndModel(myframe)
  .then((api) => {
    LwAPI = api;
    // Register a callback function for a selection event
    LwAPI?.registerOnSelection((selectedItem) => {
      if (selectedItem.item != null) {
        var treeItemSelector =
          "tree_" +
          selectedItem.item.modelId +
          ":" +
          selectedItem.item.modelItemId;
        treeDeselectAll();
        const element = document.getElementById(treeItemSelector);
        if (element) {
          element.classList.add("selected");
          element.scrollIntoView({ behavior: "smooth", block: "nearest" });
        }
      }
    });
    return api;
  })
  .catch((e) => {
    console.log("LwAPI could not be initialized: ", e);
    return null;
  });

// Build the custom tree
function buildTree() {
  LwAPI?.getTree().then((tree: LwTreeData | Array<LwTreeData>) => {
    var ul = document.createElement("ul");
    ul.classList.add("root");
    let treeData: LwTreeData | null = null;
    if (Array.isArray(tree)) {
      treeData = tree[0];
    } else treeData = tree;
    walkTree(treeData.root, ul);
    const customTree = document.querySelector("#customtree");
    if (customTree) {
      customTree.innerHTML = "";
      customTree.append(ul);
    }
  });
}

// Recursive function for building the tree
function walkTree(item: any, parent: HTMLElement) {
  // Make a tree item
  var li = document.createElement("li");
  li.classList.add(item.type);
  li.innerHTML = item.text;
  li.setAttribute("id", "tree_" + item.id);
  li.onclick = function (event) {
    event.stopPropagation();
    treeDeselectAll();
    LwAPI?.setNodeSelection(item.id, true);
  };
  // Append the tree item to its parent
  parent.append(li);

  // If the current item is an assembly, add its children to the tree
  if (item.type === "assembly") {
    var ulsub = document.createElement("ul");
    item.children.forEach(function (child: any) {
      walkTree(child, ulsub);
    });
    li.append(ulsub);
  }
}

// Clear selection in tree (called on selection change)
function treeDeselectAll() {
  document.querySelectorAll(".selected").forEach(function (item) {
    item.classList.remove("selected");
  });
}

document.getElementById("openlink")?.addEventListener("click", async () => {
  await apiReady;
  buildTree();
});
